import { REACTIONS } from '../../constants';

const imageReactionHelper = (likedImage) => {
  const newReaction = likedImage.reaction === REACTIONS.LIKE ? '' : REACTIONS.LIKE;
  const newUpdatedOn = new Date().toISOString();

  const previewCallback = (prevState) => ({
    ...prevState,
    frameData: {
      ...prevState.frameData,
      images: prevState.frameData.images.map((image) =>
        image.id === likedImage.id ? { ...image, reaction: newReaction, updatedOn: newUpdatedOn } : image,
      ),
    },
  });

  return { newReaction, newUpdatedOn, previewCallback };
};

export default imageReactionHelper;
